import { render, staticRenderFns } from "./TapesAdditionalStep.vue?vue&type=template&id=4f74cc96&scoped=true"
import script from "./TapesAdditionalStep.vue?vue&type=script&lang=js"
export * from "./TapesAdditionalStep.vue?vue&type=script&lang=js"
import style0 from "./TapesAdditionalStep.vue?vue&type=style&index=0&id=4f74cc96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f74cc96",
  null
  
)

export default component.exports